<template>
  <div class="row" style="margin-top: 55px !important;align-items: center !important;">
    <div class="col-md-8 mt-4">
        <FullCalendar :options="calendarOptions"/>
    </div>
    <div class="col-md-4 mt-4">
      <div class="wrapperDataOwner">
        <h4>Prenotazioni</h4>
        <h5><i class="far fa-calendar-alt"></i><span class="numb">{{ datas.bookingsCount }}</span></h5>
      </div>
      <div class="wrapperDataOwner mt-25">
        <h4>Notti occupate</h4>
        <h5> <i class="fas fa-moon"></i><span class="numb">{{ datas.nightsCount }}</span></h5>
      </div>
      <div class="wrapperDataOwner mt-25">
        <h4>Netto</h4>
        <h5> <i class="fas fa-euro-sign"></i><span class="numb">{{ datas.nettoProprietarioCount }}</span></h5>
      </div>
      <div class="wrapperDataOwner mt-25">
        <h4>Ospiti accolti</h4>
        <h5> <i class="fas fa-users"></i><span class="numb">{{ datas.guests }}</span></h5>
      </div>
    </div>
  </div>
</template>

<script>
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import itLocale from '@fullcalendar/core/locales/it';
import moment from 'moment'

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  name: "HouseCalendar",
  props: ['houseId'],
  data: function () {
    return {
      month: '',
      year: '',
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        locale: itLocale,
        nowIndicator: true,
        events: [],
        timeZone: 'Europe/Rome',
        datesSet: this.handleMonthChange,
      },
      datas: [],
    }
  },
  filters: {
    formatDate: function (value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY');
    }
  },
  methods: {
    getAllBookingsForCalendar() {
      axios.get('/api/get-bookings-house-calendar/' + this.houseId)
          .then(response => {
                this.calendarOptions.events = response.data.body;
              }
          )
    },
    async handleMonthChange(payload) {
      this.month = moment(payload.endStr).subtract(1, 'months').format('MM');
      if (this.month == 12) {
        this.year = moment(payload.endStr).subtract(1, 'years').format('YYYY');
      } else {
        this.year = moment(payload.endStr).format('YYYY');
      }
      this.getDatas(this.month, this.year)
    },
    getDatas(month, year) {
      axios.get('/api/get-datas-house/' + this.houseId + '/' + month + '/' + year)
          .then(response => {
                this.datas = response.data.body;
              }
          )
    },
  },
  beforeMount() {
    if (this.houseId) {
      this.getAllBookingsForCalendar()
    }
  },
}
</script>

<style scoped>

.titleH2 {
  font-size: 1.75em !important;
  margin: 0 !important;
  margin-bottom: 31px !important;
}

h2, .far, .fas {
  color: #E94E1B !important;
}

.bigNumb {
  font-size: 19px !important;
  color: #E94E1B !important;
}
</style>